import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, take } from 'rxjs';
import { ProductCategories } from '../_enums/product-categories';
import { IVendor } from '@app/_shared/_models';

@Injectable({
  providedIn: 'root'
})
export class VendorService {
  private readonly http = inject(HttpClient);

  public vendors: Array<IVendor> = [
    {
      name: 'Ahh-Some',
      category: ProductCategories.SPA,
      url: '/brands/ahh-some',
      filterUrl: '/hot-tub-care?brands=ahh-some'
    },
    {
      name: 'Amerse',
      category: ProductCategories.SPA,
      url: '/brands/amerse',
      filterUrl: '/hot-tub-care?brands=amerse'
    },
    {
      name: 'Baquacil',
      category: ProductCategories.POOL,
      url: '/brands/baquacil',
      filterUrl: '/pool-care?brands=baquacil'
    },
    {
      name: 'BioGuard',
      category: ProductCategories.BOTH,
      url: '/brands/bioguard',
      filterUrl: '/pool-care?brands=bioguard'
    },
    {
      name: 'FreshWater',
      category: ProductCategories.SPA,
      url: '/brands/freshwater',
      filterUrl: '/hot-tub-care?brands=freshwater'
    },
    {
      name: 'Frog',
      category: ProductCategories.BOTH,
      url: '/brands/frog',
      filterUrl: '/hot-tub-care?brands=frog'
    },
    {
      name: 'Hot Tub Serum',
      category: ProductCategories.SPA,
      url: '/brands/hot-tub-serum',
      filterUrl: '/hot-tub-care?brands=hot%20tub%20serum'
    },
    {
      name: 'Leisure Time',
      category: ProductCategories.SPA,
      url: '/brands/leisure-time',
      filterUrl: '/hot-tub-care?brands=leisure%20time'
    },
    {
      name: 'Poolife',
      category: ProductCategories.POOL,
      url: '/brands/poolife',
      filterUrl: '/pool-care?brands=poolife'
    },
    {
      name: 'Scumbug',
      category: ProductCategories.SPA,
      url: '/brands/scumbug',
      filterUrl: '/hot-tub-care?brands=scumbug'
    },
    {
      name: 'Sirona',
      category: ProductCategories.SPA,
      url: '/brands/sirona',
      filterUrl: '/hot-tub-care?brands=sirona'
    },
    {
      name: 'Soft Soak',
      category: ProductCategories.SPA,
      url: '/brands/soft-soak',
      filterUrl: '/hot-tub-care?brands=soft%20soak'
    },
    {
      name: 'SpaGuard',
      category: ProductCategories.SPA,
      url: '/brands/spaguard',
      filterUrl: '/hot-tub-care?brands=spaguard'
    }
  ];

  private getVendors(): Observable<any> {
    return this.http.get('https://mypoolhut.myshopify.com/admin/products/vendors.json');
  }

  public loadVendors(): void {
    this.getVendors()
      .pipe(take(1))
      .subscribe((res: any) => {
        this.vendors = res?.vendors;
      });
  }
}